export function formatDateToDDMMYYYY(dateString) {
    if (!dateString) return '';
    const months = {
        'Jan': 'January',
        'Feb': 'February',
        'Mar': 'March',
        'Apr': 'April',
        'May': 'May',
        'Jun': 'June',
        'Jul': 'July',
        'Aug': 'August',
        'Sep': 'September',
        'Oct': 'October',
        'Nov': 'November',
        'Dec': 'December'
    };

    try {
        const parts = dateString.split(' ');
        const day = parseInt(parts[2], 10); // Day
        const month = months[parts[1]]; // Month
        // Time part
        // const time = parts[3];
        // const hours = parseInt(time.substring(0, 2), 10);
        // const minutes = parseInt(time.substring(3, 5), 10);
        // const ampm = hours >= 12 ? 'pm' : 'am';
        const formattedDate = `${day} ${month}, ${'23'}:${'59'}`;
        
        return formattedDate;
    } catch (error) {
        console.error("Error parsing date:", error);
        return '';
    }
}
